import $ from "jquery"
import Swiper from "swiper"
import { EffectCreative, EffectFade, Navigation, Pagination, Scrollbar, Manipulation } from "swiper/modules"

class SliderContainer {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("SliderContainer::initialize()")

		this.slidesPerViewType = {
			xs: {
				xs: "auto", //2,
				sm: "auto", //2,
				md: "auto", //4,
				lg: "auto", //4,
				xl: "auto", //6,
				xxl: "auto", //6,
			},
			s: {
				xs: "auto", //1,
				sm: "auto", //2,
				md: "auto", //3,
				lg: "auto", //4,
				xl: "auto", //3,
				xxl: "auto", //4,
			},
			m: {
				xs: 1,
				sm: 2,
				md: 2,
				lg: 2,
				xl: 2,
				xxl: 2,
			},
			l: {
				xs: 1,
				sm: 2,
				md: 2,
				lg: 2,
				xl: 2,
				xxl: 2,
			},
			xl: {
				xs: 1,
				sm: 1,
				md: 1,
				lg: 1,
				xl: 1,
				xxl: 1,
			},
			"product-category": {
				xs: 1.3,
				sm: 2,
				md: 2.5,
				lg: 3,
				xl: 3,
				xxl: 4,
			}
		}

		this._initSliders()
		this._initEvents()
	}

	_initSliders() {
		$(".bb-slider-container").each((i, element) => {
			const teaserType =
				$(element).find(".swiper-image .bb-teaser").attr("data-teaser-type") ||
				$(element).find(".swiper-image .swiper-content-image").attr("data-teaser-type")
			const swiperImage = new Swiper($(element).find(".swiper-image")[0], {
				spaceBetween: 24,
				modules: [Navigation, Pagination, Scrollbar, Manipulation],
				slidesPerView: this.slidesPerViewType[teaserType]?.xs || 1,
				speed: 700,
				// watchSlidesProgress: true,
				scrollbar: {
					el: $(element).find(".swiper-scrollbar")[0],
					hide: true,
				},
				navigation: {
					nextEl: $(element).find(".bb-slider-container__button-next")[0],
					prevEl: $(element).find(".bb-slider-container__button-prev")[0],
				},
				breakpoints: {
					576: {
						slidesPerView: this.slidesPerViewType[teaserType]?.sm || 1,
						scrollbar: {
							// hide: false,
						},
					},
					768: {
						slidesPerView: this.slidesPerViewType[teaserType]?.md || 1,
					},
					992: {
						slidesPerView: this.slidesPerViewType[teaserType]?.lg || 1,
						spaceBetween: teaserType === "s" ? 16 : 24,
					},
					1200: {
						slidesPerView: this.slidesPerViewType[teaserType]?.xl || 1,
						spaceBetween: 24,
					},
					1920: {
						slidesPerView: this.slidesPerViewType[teaserType]?.xxl || 1,
					},
				},
				on: {
					afterInit: (swiper) => {
						this._verticalAlignContent(swiper.el)
						this._verticalAlignHeadline(swiper.el)
					},
					resize: (swiper) => {
						this._verticalAlignContent(swiper.el)
						this._verticalAlignHeadline(swiper.el)
					},
					touchMove: (swiper) => {
						if (teaserType === "xl") swiperText.setProgress(swiper.progress)
					},
					touchEnd: (swiper) => {
						if (teaserType === "xl") {
							if (Date.now() - swiper.touchEventsData.touchStartTime > swiper.params.longSwipesMs) {
								swiperText.slideToClosest(swiper.params.speed)
							} else {
								if (Math.abs(swiper.touches.diff) > swiper.params.touchRatio) {
									if (swiper.swipeDirection === "next") {
										swiperText.slideNext(swiper.params.speed)
									} else if (swiper.swipeDirection === "prev") {
										swiperText.slideTo(swiperText.activeIndex - 1, swiper.params.speed)
									}
								}
							}
						}
					},
				},
			})

			const swiperText = new Swiper($(element).find(".swiper-text")[0], {
				spaceBetween: 16,
				modules: [Navigation, EffectFade, EffectCreative, Manipulation],
				speed: 700,
				effect: "creative",
				creativeEffect: {
					prev: {
						// will set `translateZ(-400px)` on previous slides
						// translate: [0, 0, -1000],
						translate: ["-100%", 0, 0],
						opacity: 1,
					},
					next: {
						// will set `translateX(100%)` on next slides
						translate: ["100%", 0, 0],
						opacity: 1,
					},
				},
				navigation: {
					nextEl: $(element).find(".bb-slider-container__button-next")[0],
					prevEl: $(element).find(".bb-slider-container__button-prev")[0],
				},
				breakpoints: {
					576: {
						creativeEffect: {
							prev: {
								// will set `translateZ(-400px)` on previous slides
								translate: ["-100%", 0, 0],
								opacity: 1,
							},
							next: {
								// will set `translateX(100%)` on next slides
								translate: ["100%", 0, 0],
								opacity: 1,
							},
						},
					},
				},
				on: {
					touchMove: (swiper) => {
						swiperImage.setProgress(swiper.progress)
					},
					touchEnd: (swiper) => {
						if (Date.now() - swiper.touchEventsData.touchStartTime > swiper.params.longSwipesMs) {
							swiperImage.slideToClosest(swiper.params.speed)
						} else {
							if (Math.abs(swiper.touches.diff) > swiper.params.touchRatio) {
								if (swiper.swipeDirection === "next") {
									swiperImage.slideNext(swiper.params.speed)
								} else if (swiper.swipeDirection === "prev") {
									swiperImage.slideTo(swiperImage.activeIndex - 1, swiper.params.speed)
								}
							}
						}
					},
				},
			})
		})
	}

	_initEvents() {
		$("body")
			.on("mouseenter", ".swiper-image, .swiper-text", (event) => {
				if ($("body").width() >= 1200) {
					$(event.currentTarget)
						.closest(".bb-slider-container")
						.find(".bb-slider-container__scroll .swiper-scrollbar")
						.css("opacity", 1)
				}
			})
			.on("mouseleave", ".swiper-image, .swiper-text", (event) => {
				if ($("body").width() >= 1200) {
					$(event.currentTarget)
						.closest(".bb-slider-container")
						.find(".bb-slider-container__scroll .swiper-scrollbar")
						.css("opacity", 0)
				}
			})

		$(".swiper-image img").on("load", () => {
			$(".swiper-image").each((i, swiper) => {
				this._verticalAlignContent(swiper)
			})
		})
	}

	_verticalAlignContent(swiper) {
		let maxHeight = 0
		const $teaserImg = $(swiper).find(".bb-teaser__image img")
		$teaserImg.removeAttr("style")

		$teaserImg.each((k, image) => {
			maxHeight = maxHeight < $(image).outerHeight() ? $(image).outerHeight() : maxHeight
		})

		$teaserImg.css("min-height", maxHeight + "px")

		if ($(swiper).find(".bb-teaser.see-all").length) {
			$(swiper)
				.find(".bb-teaser.see-all")
				.css("height", maxHeight + "px")
		}
	}

	_verticalAlignHeadline(swiper) {
		const ratingContainerCount = $(swiper).find(".bb-teaser__rating-container").length
		const headlineCount = $(swiper).find(".bb-teaser__headline-container").length
		const isCollection = $(swiper).find(".bb-teaser--type-xs").hasClass("has-collection")

		if (!isCollection && ratingContainerCount !== 0 && headlineCount > ratingContainerCount) {
			$(swiper)
				.find(".bb-teaser__headline")
				.each((i, headline) => {
					if (
						$(headline).closest(".bb-teaser__headline-container").find(".bb-teaser__rating-container")
							.length === 0
					) {
						$(headline).addClass("extra-margin-top")
					}
				})
		}
	}
}

export default SliderContainer
